'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseBorder = exports.BORDER_SIDES = exports.BORDER_STYLE = undefined;

var _Color = require('../Color');

var _Color2 = _interopRequireDefault(_Color);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BORDER_STYLE = exports.BORDER_STYLE = {
  NONE: 0,
  SOLID: 1
};
var BORDER_SIDES = exports.BORDER_SIDES = {
  TOP: 0,
  RIGHT: 1,
  BOTTOM: 2,
  LEFT: 3
};
var SIDES = Object.keys(BORDER_SIDES).map(function (s) {
  return s.toLowerCase();
});

var parseBorderStyle = function parseBorderStyle(style) {
  switch (style) {
    case 'none':
      return BORDER_STYLE.NONE;
  }

  return BORDER_STYLE.SOLID;
};

var parseBorder = exports.parseBorder = function parseBorder(style) {
  return SIDES.map(function (side) {
    var borderColor = new _Color2.default(style.getPropertyValue('border-' + side + '-color'));
    var borderStyle = parseBorderStyle(style.getPropertyValue('border-' + side + '-style'));
    var borderWidth = parseFloat(style.getPropertyValue('border-' + side + '-width'));
    return {
      borderColor: borderColor,
      borderStyle: borderStyle,
      borderWidth: isNaN(borderWidth) ? 0 : borderWidth
    };
  });
};